export default {"src":"/_next/static/media/locationB.76de36f7.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};